var TEMPLATE_URL = require('./capture.map.html');
angular.module('ikeweb.map').directive('captureMap',
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            controller: 'CaptureMapController',
            controllerAs: 'ctrl',
            scope: {
                center: '='
            },
            bindToController: true,
            link: function($scope, $element, $attrs, ctrl) {
                ctrl.setElement($element.find('.CaptureMap'));
            }
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/capture/capture.map.directive.js
// module id = 583
// module chunks = 0